// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zx0P","title":"styles_title__2cOs5"};